export const ALLOWED_AI_FILE_EXTENSIONS = [
  'pptx',
  'docx',
  'hwp',
  'pdf',
  'csv',
  'txt',
];

export type AllowedAiFileExtension =
  (typeof ALLOWED_AI_FILE_EXTENSIONS)[number];

export const MIME_TYPES_MAP: Record<AllowedAiFileExtension, Array<string>> = {
  pptx: [
    'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  ],
  docx: [
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  ],
  hwp: [
    'application/vnd.hancom.hwp',
    'application/haansofthwp',
    'application/x-hwp',
  ],
  pdf: ['application/pdf'],
  csv: ['text/csv'],
  txt: ['text/plain'],
};

export const AcceptAiFileExtensions = [
  ...ALLOWED_AI_FILE_EXTENSIONS.map(d => `.${d}`), // 확장자
  ...ALLOWED_AI_FILE_EXTENSIONS.flatMap(d => MIME_TYPES_MAP[d]), // MIME 타입
].join(', ');

export const AiFileSizeLimitMb = 30;
